import { render, staticRenderFns } from "./setIoCard.vue?vue&type=template&id=7f2fff4c&"
import script from "./setIoCard.vue?vue&type=script&lang=js&"
export * from "./setIoCard.vue?vue&type=script&lang=js&"
import style0 from "./setIoCard.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports